//?Producción
export const BASE_URL = 'https://salute-back-production.up.railway.app';

//?Desarrollo
/* export const BASE_URL = 'http://localhost:8080'; */


